var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-full-size" },
    [
      _c(
        "div",
        { staticClass: "dialog-full-size-wrapper" },
        [
          _c(
            "div",
            { staticClass: "header" },
            [
              _c("CompassIconButton", {
                attrs: { icon: "close", size: "large" },
                on: {
                  click: function($event) {
                    return _vm.$emit("handleClose")
                  }
                }
              }),
              _vm._v(" "),
              _c("h1", [_vm._v(_vm._s(_vm.title))])
            ],
            1
          ),
          _vm._v(" "),
          _vm._t("content")
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("footer")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }